import React from 'react';
import { cn } from '../../lib/utils';

interface RecruiterInlineEmptyProps {
  icon: React.ComponentType<{ className?: string }>;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/**
 * In-page empty state — white card on slate canvas (Hiring Board empty pattern).
 */
export function RecruiterInlineEmpty({
  icon: Icon,
  title,
  description,
  action,
  className,
}: RecruiterInlineEmptyProps) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-slate-200 bg-white px-6 py-16 text-center shadow-sm',
        className,
      )}
    >
      <div className="mx-auto mb-5 flex size-14 items-center justify-center rounded-2xl bg-slate-100">
        <Icon className="size-6 text-slate-400" />
      </div>
      <h3 className="text-base font-semibold tracking-tight text-slate-900">{title}</h3>
      {description && (
        <p className="mx-auto mt-1.5 max-w-sm text-sm leading-relaxed text-slate-500">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
